import { SnackbarProvider as MuiSnackbarProvider, SnackbarProviderProps } from 'notistack';

import { NotificationsMessage } from './NotificationsMessage';

export const NotificationsProvider = (props: SnackbarProviderProps) => (
    <MuiSnackbarProvider
        {...props}
        maxSnack={3}
        preventDuplicate
        Components={{
            default: NotificationsMessage,
            error: NotificationsMessage,
        }}
    />
);
